import { BugsnagErrorHandler } from '@bugsnag/plugin-angular/dist/esm2015';

import { initializeBugsnag } from './bugsnag.client';

initializeBugsnag();

export function bugsnagErrorHandlerFactory() {
  return new BugsnagErrorHandler();
}
